(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6972],{

/***/ 83719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56727);
/* harmony import */ var components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["data", "children", "activeIndex", "labelValue", "buttonExtendedClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Dropdown = function Dropdown(_ref) {
  var data = _ref.data,
      _children = _ref.children,
      activeIndex = _ref.activeIndex,
      labelValue = _ref.labelValue,
      buttonExtendedClass = _ref.buttonExtendedClass,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox */ .Ri, _objectSpread(_objectSpread({}, props), {}, {
    as: "div",
    className: props.className ? props.className : " dropdown-default",
    onChange: props.onChange ? props.onChange : function () {},
    children: function children(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Button */ .Ri.Button, {
          className: "relative w-full select-none pl-4  pr-9 text-left font-medium leading-6 h-full".concat(buttonExtendedClass ? " ".concat(buttonExtendedClass) : ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: open ? "text-bbc-brand-700" : "text-bbc-brand-800",
            children: labelValue && labelValue !== "" ? labelValue : activeIndex
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__/* .FiChevronDown */ .b, {
            className: "absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
            size: 20
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .uT, {
          leave: "transition-all duration-200 ease-out",
          leaveFrom: "transform  opacity-50",
          leaveTo: "transform  opacity-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Options */ .Ri.Options, {
            className: "absolute z-10 mt-1 w-full select-none ".concat(props.optionsClass),
            style: props.optionsStyle,
            as: "div",
            children: _children ? _children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: " rounded-b-xl  bg-white pb-2",
              children: Array.isArray(data) && data.map(function (item, index) {
                if (item.title != activeIndex) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Option */ .Ri.Option, {
                    value: item.uri,
                    as: "div",
                    className: "block cursor-pointer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                      as: "a",
                      variant: "ghost",
                      href: item.uri,
                      useRouter: true,
                      btnDisplay: "block",
                      btnTextColor: "text-bbc-brand-700 hover:text-bbc-brand-500",
                      btnPadding: "px-4 py-2",
                      btnTextWeight: "font-normal",
                      children: item.title
                    })
                  }, index);
                }

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
              })
            })
          })
        })]
      });
    }
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.defaultProps = {
  labelValue: null,
  data: [],
  buttonExtendedClass: null,
  activeIndex: "No thing to choose"
};
/** ========== */

/***/ }),

/***/ 4227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56727);
/* harmony import */ var components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83719);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47447);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var RestrictedCountrieslist = function RestrictedCountrieslist(_ref) {
  var dataJson = _ref.dataJson;
  var dataCountries = [
  /* Africa */
  ["Niger", "Burkina Faso", "Burundi", "Central African Republic", "Democratic Republic of the Congo", "Equatorial Guinea", "Guinea - Bissau", "Libya", "Mali", "Morocco", "Nigeria", "Senegal", "Somalia", "South Sudan", "Sudan", "Uganda", "Tanzania", "Mozambique", "Chad", "Comoros"].sort(function (a, b) {
    return a.localeCompare(b);
  }),
  /* Asia */
  ["Cambodia", "Jordan", "Myanmar", "Pakistan", "Philippines", "Syria", "Turkey", "Yemen", "Iran", "The Democratic People’s Republic of Korea", "Iraq", "Afghanistan", "Turkmenistan"].sort(function (a, b) {
    return a.localeCompare(b);
  }),
  /* Australia/Oceania */
  ["American Samoa", "Fiji", "Guam", "Palau", "Samoa", "Vanuatu"].sort(function (a, b) {
    return a.localeCompare(b);
  }),
  /* Europe */
  ["Albania", "Crimea Region", "Donetsk Region", "Luhansk Region", "Gibraltar"].sort(function (a, b) {
    return a.localeCompare(b);
  }),
  /* North America */
  ["Barbados", "Haiti", "Jamaica", "US Virgin Islands", "Nicaragua"].sort(function (a, b) {
    return a.localeCompare(b);
  }),
  /* South America */
  ["Trinidad and Tobago", "Venezuela", "Cuba"].sort(function (a, b) {
    return a.localeCompare(b);
  })];
  var place = ["Africa", "Asia", "Australia/Oceania", "Europe", "North America", "South America"];

  function renderData(as2D) {
    var sOut = " <table class=\"table-policy jurisdictions table\">\n            <thead>\n              <tr class=\"border-b border-bbc-brand-800\">\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium pl-9 p-3 leading-6 whitespace-nowrap\">Africa</th>\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap\">Asia</th>\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap\">Australia/Oceania</th>\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap\">Europe</th>\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium p-3 leading-6 whitespace-nowrap\">North America</th>\n                <th class=\"text-left text-bbc-brand-800 text-sm font-medium pr-9 p-3 leading-6 whitespace-nowrap\">South America</th>\n              </tr>\n            </thead>";
    var childrenMaxLength = dataCountries.reduce(function (maxChildren, current) {
      return current.length > maxChildren.length ? current : maxChildren;
    });

    for (var x = 0; x < childrenMaxLength.length; x++) {
      // For each col
      sOut += "<tr class=' border-t border-bbc-neutral-500'>";

      for (var y = 0; y < as2D.length; y++) {
        // For each row
        sOut += "<td class='first:pl-9 px-3 py-2 leading-6 text-[14px] text-bbc-gray'>".concat(as2D[y][x] ? as2D[y][x] : " ", "</td>");
      }

      sOut += "</tr>";
    }

    sOut += "<tr class='border-t border-bbc-brand-800'><td colspan='6' class='py-3 px-9 text-[14px] text-bbc-gray'>Note: Nationalities under consideration are applicable to all members of your company,including directors, shareholders and beneficial owners.</td></tr>";
    sOut += "</table>";
    return sOut;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      minHeightBanner: "banner-min-h-600",
      breadcrumbs: dataJson.breadcrumbs,
      title: dataJson.title,
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10",
        textColor: "banner-title-gradient-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/".concat(dataJson.banner_image),
        wrapper: {
          className: "bbc-banner-image-country xl:top-28"
        },
        className: "w-full",
        width: 557,
        height: 459,
        priority: true,
        alt: "banner-img"
      }),
      bgColor: "bg-bbc-terms-policy",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "lg:py-6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "mt-10 mb-10 lg:mt-20 lg:mb-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "col-md-12 col-xs-12",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
                className: "content",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                  className: "mb-3 text-center text-bbc-gray lg:text-left",
                  children: "Before proceeding to the incorporation process, kindly note that BBCIncorp DOES NOT provide services for nationalities under the below list."
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                  className: "mb-6 text-center text-bbc-gray lg:text-left",
                  children: "The list is made based on recommendations by credible sources such as FATF as part of our effort to comply with AML/CTF regulations and are reviewed and updated from time to time."
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h5", {
                  className: "font-weight-bold mb-10 text-center text-base font-medium text-bbc-brand-700",
                  children: "High-risk and non-cooperative jurisdictions"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  dangerouslySetInnerHTML: {
                    __html: renderData(dataCountries)
                  },
                  className: "shadow-bbc hidden rounded-3xl bg-white lg:block"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "block lg:hidden",
                  children: dataCountries.map(function (item, index) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                      activeIndex: place[index],
                      className: "dropdown-default shadow-bbc relative mt-3 h-full w-full text-sm text-bbc-brand-800 first:mt-0",
                      optionsClass: "absolute mt-6",
                      optionsStyle: {
                        zIndex: 21
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                        className: "shadow-bbc shadow-bbc rounded-xl bg-white",
                        children: item.map(function (item) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Listbox.Option */ .Ri.Option, {
                            value: item,
                            as: "div",
                            className: "block border-b border-bbc-neutral-500 last:border-b-0",
                            children: function children() {
                              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                                className: "block select-none px-4 py-3 !font-normal text-bbc-black",
                                children: item
                              });
                            }
                          }, item);
                        })
                      })
                    }, index);
                  })
                })]
              })
            })
          })
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RestrictedCountrieslist);

/***/ }),

/***/ 27640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/restricted-countries-list/index.js
var restricted_countries_list = __webpack_require__(4227);
;// CONCATENATED MODULE: ./pages/vn/restricted-countries-list/data.json
var data_namespaceObject = JSON.parse('{"country":"Viet Nam","banner_image":"common/banner-rcl.png","title":"Restricted <br/>Countries List","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Restricted Countries List","uri":"/vn/restricted-countries-list"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/vn/restricted-countries-list/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "vn",
    navLight: true,
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(restricted_countries_list/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 2926:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/restricted-countries-list",
      function () {
        return __webpack_require__(27640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,4090,9738,7447,9774,2888,179], function() { return __webpack_exec__(2926); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);